export * from './Font';
export * from './Encoding';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@pdf-lib/standard-fonts/es/index.js
// module id = 857
// module chunks = 0